<section class="cst_body" *ngIf="(reimburseDetailsRes | json) != '{}'">
  <div class="container-fluid search_flt_box_main">
    <div class="user_dtl_box">
      <p>
        Employee ID :
        <span>{{reimburseDetailsRes[0].employeeId}}</span>
      </p>
      <p>
        MRN :
        <span>{{reimburseDetailsRes[0].mrn}}</span>
      </p>
      <p>
        Transaction ID :
        <span>{{reimburseDetailsRes[0].transactionId}}</span>
      </p>
      <!--<p>
        Claim ID :
        <span>{{claimId}}</span>
      </p>-->
      <p>
        Tenant Code :
        <span>{{reimburseDetailsRes[0].tenantCode}}</span>
      </p>
      <p>
        ORG Code:
        <span>{{reimburseDetailsRes[0].orgCode}}</span>
      </p>
    </div>
    <div class="customer_dtl_box">
      <div class="row">
        <div class="col">
          <div class="col-12">
            <p>Claim ID</p>
            <span>{{claimId}}</span>
          </div>
          <div class="col-12">
            <p>Customer Name</p>
            <span>{{reimburseDetailsRes[0].customerName}}</span>
          </div>
          <div class="col-12">
            <p>Family Member Mrn</p>
            <span>{{reimburseDetailsRes[0].familyMemberMrn}}</span>
          </div>
          <div class="col-12">
            <p>Business Name</p>
            <span>{{reimburseDetailsRes[0].businessName}}</span>
          </div>
          
        </div>
        <div class="col">
          <div class="col-12">
            <p>Bank Account Name</p>
            <span> {{reimburseDetailsRes[0].bankAccountName}}</span>
          </div>
          <div class="col-12">
            <p>Bank Account Number</p>
            <span>{{reimburseDetailsRes[0].bankAccountNumber}}</span>
          </div>
          <div class="col-12">
            <p>Bank Name</p>
            <span>{{reimburseDetailsRes[0].bankName}}</span>
          </div>
          <div class="col-12">
            <p>Created Date</p>
            <span><span>{{reimburseDetailsRes[0].createdDate | date:'dd/MM/yyyy hh:mm a'
                }}</span></span>
          </div>
          <!--<div class="col-12">
            <p>Line Item Date</p>
            <span>{{reimburseDetailsRes[0].lineitemDate | date:'dd/MM/yyyy hh:mm a' }}</span>
          </div>-->
          
        </div>

        <div class="col">
          <div class="col-12">
            <p><b>Doctor Name</b></p>
            <span>{{reimburseDetailsRes[0].doctorName}}</span>
          </div>
          <div class="col-12">
            <p><b>Clinic Name</b></p>
            <span>{{reimburseDetailsRes[0].clinicName}}</span>
          </div>
          <div class="col-12">
            <p><b>Clinic Pincode</b></p>
            <span>{{reimburseDetailsRes[0].clinicPincode}}</span>
          </div>
          <div class="col-12">
            <p><b>Nature Of Illness</b></p>
            <span> {{reimburseDetailsRes[0].natureOfIllness}}</span>
          </div>
        </div>
        <div class="col">
          <div class="col-12">
            <p><b>Claim Amount</b></p>
            <span> {{reimburseDetailsRes[0].requestedAmount}}</span>
          </div>
          <div class="col-12">
            <p><b>Bill Amount</b></p>
            <span> {{reimburseDetailsRes[0].lineitemAmount}}</span>
          </div>
          <div class="col-12">
            <p><b>Treatment StartDate</b></p>
            <span>{{reimburseDetailsRes[0].treatmentStartDate | date:'dd/MM/yyyy hh:mm a'}}</span>
          </div>
          <div class="col-12">
            <p><b>Treatment EndDate</b></p>
            <span>{{reimburseDetailsRes[0].treatmentEndDate | date:'dd/MM/yyyy hh:mm a'}}</span>
          </div>
        </div>
        
        <!--<div class="col">
          <div class="col-6">
            <p>Update Status &nbsp;
              <select id="inputState" class="form-control col-form-label-sm" [formControl]="status" [(ngModel)]="selectValue">
                <option disabled value="">Select Status</option>
                <option *ngFor="let status of statusList" value={{status.statusCode}}>
                  {{status.status}}</option>
              </select><br/>
              <button type="button" class="assign_btn green_btn" (click)="updateStatus()">Update</button>
            </p>
          </div>
        </div>-->

      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="table_main">

    <!--<div class="row marginTop">
      <div class="col-12 flexBox">
        <div class="payment_dtl_card">
          <div class="card_header">Treatment Details</div>
          <div class="card_body">
      <div class="row">
        <div class="col">
          <div class="col-12">
            <p><b>Doctor Name</b></p>
            <span>{{reimburseDetailsRes[0].doctorName}}</span>
          </div>
          <div class="col-12">
            <p><b>Clinic Name</b></p>
            <span>{{reimburseDetailsRes[0].clinicName}}</span>
          </div>
          <div class="col-12">
            <p><b>Clinic Pincode</b></p>
            <span>{{reimburseDetailsRes[0].clinicPincode}}</span>
          </div>    
          <div class="col-12">
            <p><b>Nature Of Illness</b></p>
            <span> {{reimburseDetailsRes[0].natureOfIllness}}</span>
          </div>    
        </div>
        <div class="col">
          <div class="col-12">
            <p><b>Claim Amount</b></p>
            <span> {{reimburseDetailsRes[0].requestedAmount}}</span>
          </div>
          <div class="col-12">
            <p><b>Bill Amount</b></p>
            <span> {{reimburseDetailsRes[0].lineitemAmount}}</span>
          </div>
          <div class="col-12">
            <p><b>Treatment Start Date</b></p>
            <span>{{reimburseDetailsRes[0].treatmentStartDate | date:'dd/MM/yyyy hh:mm a'}}</span>
          </div>
          <div class="col-12">
            <p><b>Treatment End Date</b></p>
            <span>{{reimburseDetailsRes[0].treatmentEndDate | date:'dd/MM/yyyy hh:mm a'}}</span>
          </div>          
        </div>
        </div>
          </div>
        </div>
      </div>
    </div>-->

      <!--<div class="row ">
        <div class="col-12 flexBox">
          <div class="ord_dtl_card">
            <div class="card_header ">Reimbursement Status</div>
            <div class="row container" *ngIf="isReimburStatusCheck">
              <div class="col-12 marginTop">
                <ul class="unliststyle">
                  <li>
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/new.svg" alt=""  [ngClass]="{active : reimburseResStatusList[0].statusCode == '1'}" *ngIf="reimburseResStatusList[0]" width="500" height="600">
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/new.svg" alt="" *ngIf="!reimburseResStatusList[0]">
                    <p class="desc">{{statusList[0].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[0]">{{reimburseResStatusList[0].createdDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                      <span class="bar" ></span>
                  </li>
                  <li>
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/assined.svg" alt=""  [ngClass]="{active : reimburseResStatusList[1].statusCode == '2'}" *ngIf="reimburseResStatusList[1]">
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/assined-grey.svg" alt="" *ngIf="!reimburseResStatusList[1]">
                    <p class="desc">{{statusList[1].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[1]">{{reimburseResStatusList[1].createdDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                      <span class="bar" ></span>
                  </li>
                  <li>
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/review.svg" alt=""  [ngClass]="{active : reimburseResStatusList[2].statusCode == '3'}" *ngIf="reimburseResStatusList[2]">
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/review-grey.svg" alt="" *ngIf="!reimburseResStatusList[2]">
                    <p class="desc">{{statusList[2].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[2]">{{reimburseResStatusList[2].createdDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                      <span class="bar" ></span>
                  </li>
                  <li>
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/approved.svg" alt=""  [ngClass]="{active : reimburseResStatusList[3].statusCode == '5' }" *ngIf="reimburseResStatusList[3] ">
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/approved-grey.svg" alt="" *ngIf="!reimburseResStatusList[3] ">
                    <p class="desc">{{statusList[4].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[3]">{{reimburseResStatusList[3].createdDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                      <span class="bar" ></span>
                  </li>
                  <li>
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/pending.svg" alt=""  [ngClass]="{active : reimburseResStatusList[4].statusCode == '6' }" *ngIf="reimburseResStatusList[4] ">
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/pending-grey.svg" alt="" *ngIf="!reimburseResStatusList[4]">
                    <p class="desc">{{statusList[5].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[4]">{{reimburseResStatusList[4].createdDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                      <span class="bar" ></span>
                  </li>
                  <li>
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/paid.svg" alt=""  [ngClass]="{active : reimburseResStatusList[5].statusCode == '7' }" *ngIf="reimburseResStatusList[5]">
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/paid-grey.svg" alt="" *ngIf="!reimburseResStatusList[5]">
                    <p class="desc">{{statusList[6].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[5]">{{reimburseResStatusList[5].createdDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                  </li>
                  <li>
                </ul>
            </div>
          </div>

          <div class="row container" *ngIf="isReimburStatusRejectCheck">
              <div class="col-3 marginTop">
                <ul class="unliststyle">
                  <li>
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/new.svg" alt=""  [ngClass]="{active : reimburseResStatusList[0].statusCode == '1'}" *ngIf="reimburseResStatusList[0]" width="500" height="600">
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/new.svg" alt="" *ngIf="!reimburseResStatusList[0]">
                    <p class="desc">{{statusList[0].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[0]">{{reimburseResStatusList[0].createdDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                      <span class="bar_reject" ></span>
                  </li>
                  <li >
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/approved.svg" alt=""  Class="active">
                    <p class="desc">{{statusList[3].status}}</p>
                    <p class="timestamp">{{reimburseStatusListRes[0].createdDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                  </li>
                </ul>
            </div>
          </div>

          </div>
        </div>
      </div>-->

      <div class="row">
        <div class="col-12 flexBox">
          <div class="ord_dtl_card">
            <div class="card_header ">Reimbursement Status</div>
            <div *ngIf="isReimburStatusCheck">
              <div>
               <ul class="unliststyle">
                  <li class="trackPanel">
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/new.svg"
                      [ngClass]="{active : reimburseResStatusList[0].statusCode == '1'}"
                      *ngIf="reimburseResStatusList[0]">
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/new.svg"
                      *ngIf="!reimburseResStatusList[0]">
                    <p class="desc">{{statusList[0].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[0]">{{reimburseResStatusList[0].createdDate |
                      date:'dd/MM/yyyy hh:mm a'}}</p>
                    <!-- <span class="bar" ></span> -->
                  </li>
                  <li class="trackPanel">
                    <img
                      src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/assined.svg"
                      [ngClass]="{active : reimburseResStatusList[1].statusCode == '2'}"
                      *ngIf="reimburseResStatusList[1]">
                    <img
                      src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/assined-grey.svg"
                      *ngIf="!reimburseResStatusList[1]">
                    <p class="desc">{{statusList[1].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[1]">{{reimburseResStatusList[1].createdDate |
                      date:'dd/MM/yyyy hh:mm a'}}</p>
                    <!-- <span class="bar" ></span> -->
                  </li>
                  <li class="trackPanel">
                    <img
                      src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/review.svg"
                      [ngClass]="{active : reimburseResStatusList[2].statusCode == '3'}"
                      *ngIf="reimburseResStatusList[2]">
                    <img
                      src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/review-grey.svg"
                      *ngIf="!reimburseResStatusList[2]">
                    <p class="desc">{{statusList[2].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[2]">{{reimburseResStatusList[2].createdDate |
                      date:'dd/MM/yyyy hh:mm a'}}</p>
                    <!-- <span class="bar" ></span> -->
                  </li>
                  <li class="trackPanel">
                    <img
                      src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/approved.svg"
                      [ngClass]="{active : reimburseResStatusList[3].statusCode == '5' }"
                      *ngIf="reimburseResStatusList[3] ">
                    <img
                      src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/approved-grey.svg"
                      *ngIf="!reimburseResStatusList[3] ">
                    <p class="desc">{{statusList[4].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[3]">{{reimburseResStatusList[3].createdDate |
                      date:'dd/MM/yyyy hh:mm a'}}</p>
                    <!-- <span class="bar" ></span> -->
                  </li>
                  <li class="trackPanel">
                    <img
                      src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/pending.svg"
                      [ngClass]="{active : reimburseResStatusList[4].statusCode == '6' }"
                      *ngIf="reimburseResStatusList[4] ">
                    <img
                      src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/pending-grey.svg"
                      *ngIf="!reimburseResStatusList[4]">
                    <p class="desc">{{statusList[5].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[4]">{{reimburseResStatusList[4].createdDate |
                      date:'dd/MM/yyyy hh:mm a'}}</p>
                    <!-- <span class="bar" ></span> -->
                  </li>
                  <li class="trackPanel">
                    <img
                      src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/paid.svg"
                      [ngClass]="{active : reimburseResStatusList[5].statusCode == '7' }"
                      *ngIf="reimburseResStatusList[5]">
                    <img
                      src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/paid-grey.svg"
                      *ngIf="!reimburseResStatusList[5]">
                    <p class="desc">{{statusList[6].status}}</p>
                    <p class="timestamp" *ngIf="reimburseResStatusList[5]">{{reimburseResStatusList[5].createdDate |
                      date:'dd/MM/yyyy hh:mm a'}}</p>
                  </li>
                </ul>
              </div>
            </div>
 
            <div *ngIf="isReimburStatusRejectCheck">
              <div class="">
                <ul class="unliststyle unliststyle2">
                  <li class="trackPanel">
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/new.svg" alt=""
                      Class="active">
                    <p class="desc">{{statusList[0].status}}</p>
                    <p class="timestamp">{{reimburseResStatusList[0].createdDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                  </li>
                  <li class="trackPanel">
                    <img src="https://cphateststorage.blob.core.windows.net/web-images-new/reimbursement-status/paid.svg" alt=""
                      Class="active">
                    <p class="desc">{{statusList[3].status}}</p>
                    <p class="timestamp">{{reimburseStatusListRes[0].createdDate | date:'dd/MM/yyyy hh:mm a'}}</p>
                  </li>
                </ul>
              </div>
            </div> 
          </div>
        </div>
      </div>

    </div>

<!--<div class="row ">
      <div class="col-12 ">
        <div class="payment_dtl_card">
          <div class="card_header">Uploaded Documents</div>
          <div class="card_body">
            <div class="uploadedImages">
              <div class="images_label"
                *ngIf="reimburseDetailsRes[0].prescription !='' && reimburseDetailsRes[0].prescription !=undefined && reimburseDetailsRes[0].prescription !=null">
                <label>Prescription</label>
                <div class="img_desc" (click)="download(reimburseDetailsRes[0].prescription,1)">
                  <img
                    src="https://demo.chekup.ai/assets/icons/img-icon.svg">-->
                  <!--<p class="blueMediumFont">910_vendor2.PNG</p>-->
                <!--</div>
              </div>
              <div class="images_label"
                *ngIf="reimburseDetailsRes[0].report !='' && reimburseDetailsRes[0].report !=undefined && reimburseDetailsRes[0].report !=null">
                <label>Report</label>
                <div class="img_desc" (click)="download(reimburseDetailsRes[0].report,2)">
                  <img
                    src="https://demo.chekup.ai/assets/icons/img-icon.svg">-->
                  <!--<p class="blueMediumFont">910_vendor2.PNG</p>-->
                <!--</div>
              </div>
              <div class="images_label"
                *ngIf="reimburseDetailsRes[0].invoice !='' && reimburseDetailsRes[0].invoice !=undefined && reimburseDetailsRes[0].invoice !=null">
                <label><b>Invoice</b></label>
                <div class="img_desc" (click)="download(reimburseDetailsRes[0].invoice,3)">
                  <img
                    src="https://demo.chekup.ai/assets/icons/img-icon.svg">-->
                  <!--<p class="blueMediumFont">910_vendor2.PNG</p>-->
                <!--</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <div class="row">
      <div class="col-12 ">
        <div class="payment_dtl_card">
          <div class="card_header">Uploaded Documents</div>
          <div class="card_body">
            <div class="uploadedImages">
              <div class="images_label"
                *ngIf="reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentId !='' && reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentId !=undefined && reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentId !=null">
                <label><b>Prescription</b></label>
                <div class="img_desc"
                  (click)="download(reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentId,1)">
                  <img src="assets/img/logo.png">
                  <p class="blueMediumFont">{{ reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentName }}
                  </p>
                </div>
              </div>
              <div class="images_label"
                *ngIf="reimburseDetailsRes[0].reportDetails.reportDocumentId !='' && reimburseDetailsRes[0].reportDetails.reportDocumentId !=undefined && reimburseDetailsRes[0].reportDetails.reportDocumentId !=null">
                <label><b>Report</b></label>
                <div class="img_desc" (click)="download(reimburseDetailsRes[0].reportDetails.reportDocumentId,2)">
                  <img src="assets/img/logo.png">
                  <p class="blueMediumFont">{{ reimburseDetailsRes[0].reportDetails.reportDocumentName }}</p>
                </div>
              </div>
              <div class="images_label"
                *ngIf="reimburseDetailsRes[0].invoiceDetails.invoiceDocumentId !='' && reimburseDetailsRes[0].invoiceDetails.invoiceDocumentId !=undefined && reimburseDetailsRes[0].invoiceDetails.invoiceDocumentId !=null">
                <label><b>Invoice</b></label>
                <div class="img_desc" (click)="download(reimburseDetailsRes[0].invoiceDetails.invoiceDocumentId,3)">
                  <img src="assets/img/logo.png">
                  <p class="blueMediumFont">{{ reimburseDetailsRes[0].invoiceDetails.invoiceDocumentName }}</p>
                </div>
              </div>
            </div>
            <div class="noImages" *ngIf="reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentId =='' &&  reimburseDetailsRes[0].reportDetails.reportDocumentId ==''  && reimburseDetailsRes[0].invoiceDetails.invoiceDocumentId =='' ">
              <b>
                No Documents Found
              </b>
            </div> 
          </div>
        <div class="card_header">Remarks</div>
          <div class="card_body">
            <div *ngFor="let remark of reimburseResStatusList; let i=index">
              <div *ngIf="remark.statusCode == 4 && remark.remarks != null">
                <p class="statusTitle"><b>{{statusList[3].status}} </b></p>
                <p>{{remark.remarks}} </p>
              </div>
              <div *ngIf="remark.statusCode == 5 && remark.remarks != null">
                <p class="statusTitle"><b>{{statusList[4].status}} </b></p>
                <p>{{remark.remarks}} </p>
              </div>
              <div class="noImages"
                *ngIf=" remark.statusCode == 4 &&  remark.remarks == null || remark.statusCode == 5 &&  remark.remarks == null">
                <b>
                  No Remarks Found
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="row" *ngIf="reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentId !='' || reimburseDetailsRes[0].reportDetails.reportDocumentId !='' || reimburseDetailsRes[0].invoiceDetails.invoiceDocumentId !=''">
      <div class="col-12 ">
        <div class="payment_dtl_card">
          <div class="card_header">Uploaded Documents</div>
          <div class="card_body">
            <div class="uploadedImages">
              <div class="images_label"
                *ngIf="reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentId !='' && reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentId !=undefined && reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentId !=null">
                <label><b>Prescription</b></label>
                <div class="img_desc" (click)="download(reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentId,1)">
                  <img
                    src="https://demo.chekup.ai/assets/icons/img-icon.svg">
                  <p class="blueMediumFont">{{ reimburseDetailsRes[0].prescriptionDetails.prescriptionDocumentName }}</p>
                </div>
              </div>
              <div class="images_label"
                *ngIf="reimburseDetailsRes[0].reportDetails.reportDocumentId !='' && reimburseDetailsRes[0].reportDetails.reportDocumentId !=undefined && reimburseDetailsRes[0].reportDetails.reportDocumentId !=null">
                <label><b>Report</b></label>
                <div class="img_desc" (click)="download(reimburseDetailsRes[0].reportDetails.reportDocumentName,2)">
                  <img
                    src="https://demo.chekup.ai/assets/icons/img-icon.svg">
                  <p class="blueMediumFont">{{ reimburseDetailsRes[0].reportDetails.reportDocumentName }}</p>
                </div>
              </div>
              <div class="images_label"
                *ngIf="reimburseDetailsRes[0].invoiceDetails.invoiceDocumentId !='' && reimburseDetailsRes[0].invoiceDetails.invoiceDocumentId !=undefined && reimburseDetailsRes[0].invoiceDetails.invoiceDocumentId !=null">
                <label><b>Invoice</b></label>
                <div class="img_desc" (click)="download(reimburseDetailsRes[0].invoiceDetails.invoiceDocumentId,3)">
                  <img
                    src="https://demo.chekup.ai/assets/icons/img-icon.svg">
                  <p class="blueMediumFont">{{ reimburseDetailsRes[0].invoiceDetails.invoiceDocumentName }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
  </div>

  <div class="row mrg-lr-no">
    <div class="col-md-12">
      <div class="pull-right">
          <button type="button" class="btn green_btn"  *ngIf="isReimbursNew" (click)="openReimburseModal(1,reimburseDetailsRes[0])">New</button>
          <button type="button" class="btn green_btn"  *ngIf="isReimbursAssigned" (click)="openReimburseModal(2,reimburseDetailsRes[0])">Assign</button>
          <button type="button" class="btn green_btn"  *ngIf="isReimbursInreview" (click)="updateStatus(3)">In review</button>
          <button type="button" class="btn green_btn"  *ngIf="isReimbursApproved" (click)="openReimburseModal(5,reimburseDetailsRes[0])">Approve</button>
          <button type="button" class="btn green_btn"  *ngIf="isReimbursPaymentPending" (click)="updateStatus(6)">Payment Release</button>
          <button type="button" class="btn orange_btn"  *ngIf="isReimbursRejected" (click)="openReimburseModal(4,reimburseDetailsRes[0])">Rejected</button>
          <button type="button" class="btn green_btn" *ngIf="isReimbursPaid" (click)="openReimburseModal(7,reimburseDetailsRes[0])">Mark Reimburse as Paid</button>

          <!--<button type="button" class="btn green_btn" *ngIf="isReimbursCompleted">Mark Reimburse as Completed</button>  -->

          <!--<button type="button" class="btn green_btn" *ngIf="isReimbursRejectCompleted" >Marked Reimburse as Rejected</button>            -->
      </div>
      <div class="pull-left">
        <button type="button" class="btn closeGreenBordBtn" (click)="CloseTab()">Close</button>
      </div>
    </div>
  </div>
</section>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">Please Wait. </p>
</ngx-spinner>

<!--Delete Test Modal-->